"use client";
import React from "react";
import VenueLocationCard from "../Ticket/sections/VenueLocationCard.jsx";

function Location({ locationData, venue, title }) {
  const mergedVenue = {
    ...venue,
    ...locationData,
    lat: locationData?.location?.lat ?? venue?.lat ?? locationData?.lat,
    long:
      locationData?.location?.lng ??
      venue?.long ??
      venue?.lng ??
      locationData?.long ??
      locationData?.lng,
    google_place_id:
      locationData?.placeId ??
      locationData?.place_id ??
      venue?.google_place_id ??
      venue?.place_id,
    name: locationData?.name || venue?.name,
    address:
      locationData?.address ||
      locationData?.formatted_address ||
      venue?.address,
  };

  if (!locationData && !venue) return null;

  return (
    <div className="w-full">
      {title && (
        <h2 className="text-4xl font-extrabold mb-6">{title ? title : null}</h2>
      )}
      <VenueLocationCard
        venue={mergedVenue}
        venueObject={mergedVenue}
        yetToBeAnnounced={false}
      />
    </div>
  );
}

export default Location;
